module.exports = "/_next/static/images/aea091be70985d1f0fbc34e48c8fa985-cuenta-card-xs.png.webp";